import { createContext } from 'react';
import { EntityValue } from '../entities/entity-value';
import { TopicExpertiseValue } from '../entities/topic-expertise-value';
import { TrendExpertiseValue } from '../entities/trend-expertise-value';
import { OrganisationValue } from '../entities/organisation-value';
import { PersonValue } from '../entities/person-value';
import { ObjectiveValuePill } from '../entities/objective-value-pill';
import { TeamValue } from '../entities/team-value';
export var defaultEntityTypeValuesSet = {
  Entity: EntityValue,
  TrendExpertise: TrendExpertiseValue,
  TopicExpertise: TopicExpertiseValue,
  Objective: ObjectiveValuePill,
  Organisation: OrganisationValue,
  Person: PersonValue,
  Team: TeamValue
};
export var EntityTypeValuesContext = createContext(defaultEntityTypeValuesSet);
export var EntityTypeValuesProvider = EntityTypeValuesContext.Provider;